import { theme } from '../styles/theme'
import { useState } from 'react'

export const isBrowser = typeof window !== 'undefined'

// Outdated helper kept here for backwards compatibility
// This one only calculates once on page load
export const isMobile = () => isBrowser && window.innerWidth < theme.breakpoints.values.md

// New helper to identify if the screen is mobile
// This one will update on page load and resize
export function useIsMobile (initialState = true) {
  const [state, setState] = useState(initialState)
  const handleResize = () => {
    console.log('useIsMobile handleresize called', window.innerWidth, theme.breakpoints.values.md, window.innerWidth < theme.breakpoints.values.md)
    setState(window.innerWidth < theme.breakpoints.values.md)
  }

  // First check if there is already a resize event listener, if not, add it
  if (!window.resizeEventAdded) {
    window.addEventListener('resize', handleResize)
    window.resizeEventAdded = true
    handleResize() // Call it once to set the initial state
    // Call it in 300ms as well
    setTimeout(() => {
      handleResize()
    }, 300)
  }
  return [state, setState]
}
